const system = {
  state: {
    showLoader: false,
    alertColor: '',
    showAlert: false,
    loaderMessage: '',
    alertMessage: '',
    systemTopBarColor: 'primary',
    drawerToggle: false,
    dialogToolbarColor: 'info',
    isApiLoading: false
    // tinymceEditorStyle: 'p { margin-block-start: 0em!important; margin-block-end: 0em!important; margin-inline-start: 0px!important; margin-inline-end: 0px!important;}'
  },
  mutations: {
    SET_SHOW_LOADER: (state, loaderObj) => {
      state.showLoader = loaderObj.status
      state.loaderMessage = loaderObj.message
    },
    SET_SHOW_ALERT: (state, alertObj) => {
      state.showAlert = alertObj.showAlert
      state.alertMessage = alertObj.message
      state.alertColor = alertObj.color
    },
    SET_IS_API_LOADING: (state, data) => {
      state.isApiLoading = data
    },
    SET_TOPBAR_COLOR: (state, color) => {
      state.systemTopBarColor = color
    },
    SET_TOGGLE_DRAWER: (state, color) => {
      state.drawerToggle = color
    },
    SET_DIALOG_TOOLBAR_COLOR: (state, color) => {
      state.dialogToolbarColor = color
    }
  },
  actions: {
    SetLoader ({commit}, loaderObj) {
      commit('SET_SHOW_LOADER', loaderObj)
    },
    SetAlert ({commit}, alertObj) {
      commit('SET_SHOW_ALERT', alertObj)
    },
    SetIsApiRunning ({commit}, data) {
      commit('SET_IS_API_LOADING', data)
    },
    SetTopBarColor ({commit}, color) {
      commit('SET_TOPBAR_COLOR', color)
    },
    SetLeftDrawerToggle ({commit}, toggle) {
      commit('SET_TOGGLE_DRAWER', toggle)
    },
    SetDialogToolBarColor ({commit}, color) {
      commit('SET_DIALOG_TOOLBAR_COLOR', color)
    }
  }
}

export default system



// WEBPACK FOOTER //
// ./src/store/modules/system.js